import { render, staticRenderFns } from "./SelectRateVersions.vue?vue&type=template&id=0ad72f1f&scoped=true"
import script from "./SelectRateVersions.vue?vue&type=script&lang=js"
export * from "./SelectRateVersions.vue?vue&type=script&lang=js"
import style0 from "./SelectRateVersions.vue?vue&type=style&index=0&id=0ad72f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad72f1f",
  null
  
)

export default component.exports